import httpClient from "../http/http-client";
import { IProductEntry } from './finishedProductEntry.model';

export default class FinishedProductEntryService {
  http;

  constructor() {
    this.http = httpClient
  }

  async create(details: IProductEntry): Promise<IProductEntry> {
    return this.http.post(`finished-product-entry/create`, details)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  // async upgrade(details: IUpdateToProductEntry): Promise<IUpdateToProductEntry> {
  //   return this.http.post(`finished-product-entry/upgrade`, { ...details })
  //     .then(response => {
  //       return response.data
  //     })
  //     .catch(err => {
  //       console.log(err);
  //       throw err;
  //     });
  // }

  async getAll(reportPeriodIdAndEntryType: string): Promise<IProductEntry[]> {
    return this.http.get(`finished-product-entry${reportPeriodIdAndEntryType}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  // async deleteOne(finishedProductEntryId: string): Promise<IProductEntry[]> {
  //   return this.http.delete(`finished-product-entry/delete/${finishedProductEntryId}`)
  //     .then(response => {
  //       return response.data
  //     })
  //     .catch(err => {
  //       console.log(err);
  //       throw err;
  //     });
  // }
}